module.exports = {
    content: [
        './index.html',
        './src/**/*.{vue,js,ts}',
    ],
    theme: {
        extend: {
            /**
             * ⚠️ IMPORTANT: These colors reference CSS variables defined in `evidentColors.scss`.
             * Make sure that file is imported on application's global styles
             * so that the variables exist at runtime. Otherwise, these Tailwind classes will have no effect.
             */
            colors: {
                eidGreen: {
                    DEFAULT: 'var(--eidGreen)',
                },
                eidTrustGreen: {
                    DEFAULT: 'var(--eidTrustGreen)',
                    75: 'var(--eidTrustGreen-75)',
                    50: 'var(--eidTrustGreen-50)',
                    25: 'var(--eidTrustGreen-25)',
                    10: 'var(--eidTrustGreen-10)',
                },
                eidSecureBlue: {
                    DEFAULT: 'var(--eidSecureBlue)',
                    75: 'var(--eidSecureBlue-75)',
                    50: 'var(--eidSecureBlue-50)',
                    25: 'var(--eidSecureBlue-25)',
                    10: 'var(--eidSecureBlue-10)',
                },
                eidQualityBlack: {
                    DEFAULT: 'var(--eidQualityBlack)',
                    75: 'var(--eidQualityBlack-75)',
                    50: 'var(--eidQualityBlack-50)',
                    25: 'var(--eidQualityBlack-25)',
                    10: 'var(--eidQualityBlack-10)',
                },
                eidTechGray: {
                    DEFAULT: 'var(--eidTechGray)',
                    75: 'var(--eidTechGray-75)',
                    50: 'var(--eidTechGray-50)',
                    25: 'var(--eidTechGray-25)',
                    10: 'var(--eidTechGray-10)',
                },
                eidSafetyBlue: {
                    DEFAULT: 'var(--eidSafetyBlue)',
                    75: 'var(--eidSafetyBlue-75)',
                    50: 'var(--eidSafetyBlue-50)',
                    25: 'var(--eidSafetyBlue-25)',
                    10: 'var(--eidSafetyBlue-10)',
                },
                eidImpactOrange: {
                    DEFAULT: 'var(--eidImpactOrange)',
                    75: 'var(--eidImpactOrange-75)',
                    50: 'var(--eidImpactOrange-50)',
                    25: 'var(--eidImpactOrange-25)',
                    10: 'var(--eidImpactOrange-10)',
                },
                eidSuccessGreen: {
                    DEFAULT: 'var(--eidSuccessGreen)',
                    75: 'var(--eidSuccessGreen-75)',
                    50: 'var(--eidSuccessGreen-50)',
                    25: 'var(--eidSuccessGreen-25)',
                    10: 'var(--eidSuccessGreen-10)',
                },
                eidWarningYellow: {
                    DEFAULT: 'var(--eidWarningYellow)',
                    75: 'var(--eidWarningYellow-75)',
                    50: 'var(--eidWarningYellow-50)',
                    25: 'var(--eidWarningYellow-25)',
                    10: 'var(--eidWarningYellow-10)',
                },
                eidDangerRed: {
                    DEFAULT: 'var(--eidDangerRed)',
                    75: 'var(--eidDangerRed-75)',
                    50: 'var(--eidDangerRed-50)',
                    25: 'var(--eidDangerRed-25)',
                    10: 'var(--eidDangerRed-10)',
                },
                eidDarkBlue: {
                    DEFAULT: 'var(--eidDarkBlue)',
                    75: 'var(--eidDarkBlue-75)',
                    50: 'var(--eidDarkBlue-50)',
                },
                eidLightGray: {
                    DEFAULT: 'var(--eidLightGray)',
                    75: 'var(--eidLightGray-75)',
                    50: 'var(--eidLightGray-50)',
                    25: 'var(--eidLightGray-25)',
                },
                eidBgGrayTones: {
                    lighter: 'var(--eidBgGrayTones-lighter)',
                    lightest: 'var(--eidBgGrayTones-lightest)',
                },
                eidWhite: {
                    default: 'var(--eidWhite)',
                },
            },
            fontSize: {
                '2.5xl': [ '26px' ],
                'xxs': [ '10px' ],
            },
        },
    },
    plugins: [],
    corePlugins: {
        preflight: false,
    },
};
